"use client";

import { useState, useEffect } from "react";
import UsedProductsIndustry from "@/components/usedProducts/UsedProductsIndustry";
import UsedProductsFamily from "@/components/usedProducts/UsedProductsFamily";
import { UsedProductFamily, UsedProductIndustry } from "@/@types";
import Image from "next/image";
import { useRouter, usePathname } from "next/navigation";
import { ROUTES } from "@/config/routes";

interface Props {
  usedProductIndustry: UsedProductIndustry[];
  usedProductFamily: UsedProductFamily[];
  isMenuOpen?: boolean;
  toggleMenu?: () => void;
}

export default function UsedProductsFiltersContainer({
  usedProductIndustry,
  usedProductFamily,
  isMenuOpen = false,
  toggleMenu = () => { },
}: Props) {
  const [showMenuIcon, setShowMenuIcon] = useState(false);
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    const handleScroll = () => {
      setShowMenuIcon(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  const handleRestore = () => {
    router.replace(ROUTES.usedEquipments.root);
  };

  const renderTodos = () => {
    if (pathname === `${ROUTES.usedEquipments.root}/` || !pathname.includes(`${ROUTES.usedEquipments.root}/`)) return null;

    return (
      <div className="relative block bg-white">
        <button
          onClick={handleRestore}
          className="w-full inline-flex items-center justify-center px-4 py-2 text-gray hover:text-black transition-colors cursor-pointer hover:bg-gray-50 rounded-md"
        >
          <Image
            src="/images/icons/restoreIcon.svg"
            alt="restaurar"
            width={16}
            height={16}
            className="flex-shrink-0"
          />
          <span className="ml-3 text-sm font-medium">
            RESTAURAR
          </span>
        </button>
      </div>
    )
  }

  return (
    <>
      <div className="hidden lg:flex flex-col gap-4">
        {renderTodos()}
        <UsedProductsIndustry usedProductIndustry={usedProductIndustry} />
        <UsedProductsFamily usedProductFamily={usedProductFamily} />
      </div>

      {showMenuIcon && !isMenuOpen && (
        <button
          onClick={toggleMenu}
          className="fixed bottom-5 left-5 bg-yellow-500 text-white p-4 rounded-full shadow-lg lg:hidden z-50"
        >
          <Image
            src="/assets/icons/filter.svg"
            alt="Filtros"
            width={20}
            height={20}
            className="h-5 w-5"
          />
        </button>
      )}

      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-end lg:hidden z-50"
          onClick={toggleMenu}
        >
          <div
            className="w-full bg-white p-6 rounded-t-2xl shadow-lg overflow-y-auto max-h-[80vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-semibold text-lg">Filtros</h3>
              <button onClick={toggleMenu} className="text-2xl font-semibold">
                ✕
              </button>
            </div>
            {renderTodos()}
            <UsedProductsIndustry usedProductIndustry={usedProductIndustry} />
            <UsedProductsFamily usedProductFamily={usedProductFamily} />
          </div>
        </div>
      )}
    </>
  );
}
